"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_1 = require("url");

var request_promise_1 = __importDefault(require("request-promise"));

var isUri = require('valid-url').isUri;
/**
 * The internal library of node-bitly
 * @module node-bitly.lib
 * @private
 */


var DEFAULT_OPTIONS = {
  apiUrl: 'api-ssl.bitly.com',
  apiVersion: 'v3',
  domain: 'bit.ly',
  format: 'json'
};
/**
 * Generates a valid URL for a GET request to the Bit.ly API
 * @param {object} UrlParameters An object of paramters to pass to generate a bit.ly url
 * @param {string} accessToken Your bit.ly access token
 * @param {string} method The method to call
 * @param {object} data a data object specifying bit.ly keys for your method
 * @param {object} config A custom config object to overide values
 * @private
 *
 * @example
 * ```js
 * generateUrl({method: 'shorten', accessKey: 'myaccessKey', data: { longUrl: 'https://github.com/tanepiper/node-bitly' } });
 * ```
 */

function generateUrl(accessToken, method, data, config) {
  if (data === void 0) {
    data = {};
  }

  if (config === void 0) {
    config = {};
  }

  var newQuery = Object.assign({
    access_token: accessToken,
    domain: config.domain || DEFAULT_OPTIONS.domain,
    format: config.format || DEFAULT_OPTIONS.format
  });
  Object.keys(data || []).forEach(function (key) {
    return newQuery[key] = data[key];
  });
  return url_1.parse(url_1.format({
    protocol: 'https',
    hostname: config.apiUrl || DEFAULT_OPTIONS.apiUrl,
    pathname: "/" + (config.apiVersion || DEFAULT_OPTIONS.apiVersion) + "/" + method,
    query: newQuery
  }));
}

exports.generateUrl = generateUrl;
/**
 * Method called to generate a url and call the request
 * @param {object} options The options object
 * @param {string} options.accessToken The request accessToken
 * @param {string} options.method The method to be called on Bitly
 * @param {object} options.data A data object with key=>value pairs mapped to request parameters
 * @param {config} options.config A object that overrides the default values for a request
 * @returns {object} The request result object
 */

function doRequest(accessToken, method, data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var uri, req, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          uri = generateUrl(accessToken, method, data, config);
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , request_promise_1.default({
            uri: uri
          })];

        case 2:
          req = _a.sent();
          return [2
          /*return*/
          , JSON.parse(req)];

        case 3:
          error_1 = _a.sent();
          throw error_1;

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.doRequest = doRequest;
/**
 * Function to check through an array of items to check for short urls or hashes
 * If only passed one item, put in array for url checking
 * @param  {Array<string>} unsortedItems The array of items to be checked
 * @param  {object} query The query object
 * @return {object}
 */

function sortUrlsAndHash(unsortedItems, result) {
  if (result === void 0) {
    result = {
      shortUrl: [],
      hash: []
    };
  }

  result.shortUrl = result.shortUrl || [];
  result.hash = result.hash || [];
  (Array.isArray(unsortedItems) ? unsortedItems : [unsortedItems]).map(function (item) {
    return isUri(item) ? result.shortUrl.push(item) : typeof item === 'string' && result.hash.push(item);
  });
  return result;
}

exports.sortUrlsAndHash = sortUrlsAndHash;